import React, {useCallback, useEffect, useState} from "react";
import {useThemeSelector} from "../../../hooks/theme/useThemeSelector";
import {LottiePlayerComponent} from "./LottiePlayerComponent";
import {ThemeElementType} from "../../../hooks/theme/ThemeElementType";
import {VastBankLotties} from "../theme-provider/lotties/VastBankLotties";
import {Lotties} from "../theme-provider/lotties/Lotties";
import {EmergeLotties} from "../theme-provider/lotties/EmergeLotties";
import {SquareOneLotties} from "../theme-provider/lotties/SquareOneLotties";

interface ThemedLottiePlayerComponentProps {
    animation: string
}

export const ThemedLottiePlayerComponent: React.FC<ThemedLottiePlayerComponentProps> = ({animation}: ThemedLottiePlayerComponentProps) => {
    const { theme } = useThemeSelector()
    const [themedLotties, setThemedLotties] = useState<Lotties | null>(null)
    const [themedLottie, setThemedLottie] = useState()

    const applyChosenAnimation = useCallback(() => {
        let dynamicKey = animation as keyof Lotties;
        if (themedLotties) {
            const lottie = themedLotties[dynamicKey]
            if (lottie) {
                setThemedLottie(lottie)
            }
        }

    }, [themedLotties, animation])

    const getThemedLotties = useCallback(() => {
        if (theme) {
            switch (theme.toUpperCase()) {
                case ThemeElementType.VASTBANK:
                    setThemedLotties(VastBankLotties)
                    break
                case ThemeElementType.EMERGE:
                    setThemedLotties(EmergeLotties)
                    break
                case ThemeElementType.SQUAREONE:
                    setThemedLotties(SquareOneLotties)
                    break
                default:
                    setThemedLotties(EmergeLotties)
            }
        }
    }, [theme])

    useEffect(() => {
        getThemedLotties()
    }, [getThemedLotties, theme]);

    useEffect(() => {
        applyChosenAnimation()
    }, [applyChosenAnimation, themedLotties, animation]);

    return themedLottie ? (<LottiePlayerComponent animationData={themedLottie}/>) : (<span></span>)
}